import React from "react";
import { useDispatch } from "react-redux";
import { updateInfoUser } from "../../../redux/userSlice/userSlice";
import notify from "../../../hooks/useNotifaction";

export default function UpdateUser({ currentUser, setCurrentUser }) {
  const dispatch = useDispatch();
  async function handleForm(e) {
    e.preventDefault();
    try {
      await dispatch(updateInfoUser({ id: currentUser.id, data: currentUser })).unwrap();
    } catch (error) {
      notify(error?.message, "error");
    }
  }
  return (
    <>
      <form className="col-md-8" onSubmit={handleForm}>
        <div className="card mb-3 pt-5 pb-2 px-3">
          <section className="row mb-5">
            <h4>
              {" "}
              <span>البيانات الشخصية</span>
            </h4>
            {/* compny */}
            <div className="col-12 mt-3 mb-2">
              <div>
                <label htmlFor="UserName"> الاسم </label>
                <input type="text" name="name" value={currentUser?.name} onChange={(e) => setCurrentUser({ ...currentUser, name: e.target.value })} placeholder=" الاسم " id="UserName" className="form-control" />
              </div>
            </div>
          </section>

          <section className="row mb-3">
            <h4>
              <span>بيانات التواصل</span>
            </h4>
            <div className="col-md-6 mb-2">
              <div>
                <label htmlFor="Number" className="mt-3">
                  رقم الهاتف
                </label>
                <input type="text" placeholder="رقم الهاتف" id="Number" className="form-control" />
              </div>
            </div>
            <div className="col-md-6">
              <div>
                <label htmlFor="email" className="mt-3">
                  البريد الاليكتروني
                </label>
                <input type="email" name="email" value={currentUser?.email} onChange={(e) => setCurrentUser({ ...currentUser, email: e.target.value })} placeholder="البريد الاليكتروني" id="email" className="form-control" />
              </div>
            </div>
          </section>
          <div>
            <button className="btn btn-primary">حفظ</button>
          </div>
        </div>
      </form>
    </>
  );
}
